import { Clickable, Col, Icon, Row, Text } from 'components';
import { useOutsideClick } from 'core';
import { nations, theme } from 'lib';
import { useRef, useState } from 'react';
import styled from 'styled-components';

const OptionsWrapper = styled.div`
  position: absolute;
  max-height: 350px;
  width: 552px;
  border-radius: 8px;
  left: 0;
  top: 35px;
  background: #fff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
  overflow-y: scroll;
  scrollbar-width: none;
  padding: 12px 0px;
  z-index: 2;
`;

const Option = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.left ? 'flex-start' : 'center')};
  height: 54px @media (max-width: 1024px) {
    height: 39px;
  }
`;

const NationCodeDropdown = ({ selected, handleNationSelect, inputRef }) => {
  const [visible, setVisible] = useState(false),
    wrapperRef = useRef();

  useOutsideClick(wrapperRef, () => setVisible(false));

  function handleVisible() {
    setVisible(!visible);
  }

  function handleSelect(item) {
    handleNationSelect(item);
    handleVisible();
  }

  return (
    <Col ref={wrapperRef} noFlex pos="relative">
      <Row centerAll noFlex>
        <Clickable onClick={handleVisible} marg="0 24px 0 0">
          <Row noFlex centerAll>
            <Icon type={selected?.icon || nations[0].icon} />

            <Icon type={visible ? 'up' : 'down'} dimensions={12} marg="0 0 0 6px" />
          </Row>
        </Clickable>

        <Text size="15px" col={theme.GREY_60} marg="0 6px 0 0">
          +{selected?.code || '0'}
        </Text>
      </Row>

      {visible && (
        <OptionsWrapper>
          {nations?.map((item, i) => {
            const isSelected = selected?.code === item.code;

            return (
              <Clickable onClick={() => handleSelect(item)} key={i}>
                <Row between pad="11px 16px" wid="calc(100% - 32px)" ht="22px">
                  <Text b1 med wid="100%">
                    {item.value}
                  </Text>

                  {isSelected && <Icon type="done" col={theme.SECONDARY} />}
                </Row>
              </Clickable>
            );
          })}
        </OptionsWrapper>
      )}
    </Col>
  );
};

export default NationCodeDropdown;
